// extracted by mini-css-extract-plugin
module.exports = {"root":"download-link-module--root--1oPMC","title":"download-link-module--title--1uVX1","mime":"download-link-module--mime--3gt4f"};